import React from "react";
import { NewTab } from "../../../components";
import { useModuleAccess } from "../../../hooks";
import Leads from "./Leads/Leads";
import Configuration from "./Configuration/Configuration";


const PriorityLeads = () => {
  const LeadsMenus = [
    {
      title: "Leads",
      page: <Leads />,
      type: "main",
      id: "priorityleads_leads",
    },
    {
      title: "Configuration",
      page: <Configuration />,
      type: "main",
      id: "priorityleads_configuration",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: LeadsMenus,
    parentId: "priorityleads",
  });
  return (
    <div className="flex-1 flex  overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="account-details"
      />
    </div>
  );
};

export default PriorityLeads;
